import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, finalize, Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { LoaderService } from "./Shared Utilities/global-loader/loader.service";
import { ToastrService } from "ngx-toastr";
import { UserLoginService } from "./login/userlogin.service";
import { dynamicEnvironment } from "./Common/DynamicEnvironment/DynamicEnvironment";

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private toaster: ToastrService,
    private authService: UserLoginService
  ) {}
  private sessionExpiredToastShown = false;
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const currURL = request.url;

    const hostname = new URL(currURL, window.location.origin).hostname;

    if (hostname.startsWith("erp.") || currURL.includes("vnccy.com")) {
      request = request.clone({
        setHeaders: { CompanyId: "1", BranchId: "1", SoftwareId : "1" },
      });
    }

    const token = localStorage.getItem("access_token");

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg = "";
        if (error.error instanceof ErrorEvent) {
          console.error("This is CLIENT side error");
          errorMsg = `Error: ${error.error.message}`;
        } else {

          errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;

          if (error.status == 401) {
            if (!this.sessionExpiredToastShown) {
              this.sessionExpiredToastShown = true; // Set the flag
              this.toaster.error("Session Expired! Please log in again.");
              this.authService.SignOutUser();
            }
          } else {
            console.error(error.error);

            if (error.error != "Token Expired") {
              if (error.error["Message"] && error.error["Message"].length > 0) {
                if (
                  !(
                    error.error["Message"].trim().toLowerCase() ===
                    "sequence contains no elements"
                  )
                )
                  this.toaster.error(error.error["Message"]);
              } else {
                this.toaster.error(error.error);
              }
            }
          }
        }
        return throwError(() => errorMsg);
      }),
      finalize(() => {})
    );
  }
}
